import * as React from 'react';
import { SVGProps } from 'react';

const IconRoubleSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.52 3.437h-.683v2.206h.674c.72 0 1.203-.38 1.203-1.107S7.231 3.437 6.52 3.437Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10Zm3-6.5c0 1.429-1.076 2.143-2.286 2.143h-.877v.786h2.306v.714H5.837V9.57H4.57V8.143H3.5v-.714h1.071v-.786H3.5v-1h1.071V2.429h2.143C7.9 2.429 9 3.07 9 4.5Z"
    />
  </svg>
);
export default IconRoubleSizeXs;
